import { render, staticRenderFns } from "./Cytology.vue?vue&type=template&id=2c7ebc4d&scoped=true&"
import script from "./Cytology.vue?vue&type=script&lang=js&"
export * from "./Cytology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ebc4d",
  null
  
)

export default component.exports